import {
  civilDateAt,
  formatCivilDate,
  formatInstant,
  isCivilDate,
  parseInstant,
} from '@/shared/format/date';
import { formatDocument, maskDocumentInput } from '@/shared/format/document';

export function bankSlipInputDate(value: string | null | undefined) {
  if (value == null || value === '') return null;
  if (isCivilDate(value)) return value;
  const instant = parseInstant(value);
  return instant ? civilDateAt(instant) : null;
}

export function bankSlipWireDate(value: unknown) {
  if (value === null || value === undefined || value === '') return value;
  if (typeof value !== 'string') throw new Error('Invalid bank slip date');
  if (isCivilDate(value)) return `${value}T00:00:00.000-03:00`;
  const instant = parseInstant(value);
  if (!instant) throw new Error('Invalid bank slip date');
  // U02: preserve the instant while serializing the legacy fixed offset.
  return `${new Date(instant.getTime() - 3 * 60 * 60 * 1000).toISOString().slice(0, -1)}-03:00`;
}

export function bankSlipInstantDate(value: string | null | undefined, locale: string) {
  if (!value) return null;
  return isCivilDate(value)
    ? formatCivilDate(value, { locale })
    : formatInstant(value, { locale, time: false });
}

export function bankSlipPersonLabel(
  value:
    | {
        businessName?: string | null | undefined;
        name?: string | null | undefined;
        registrationNumber?: string | null | undefined;
      }
    | null
    | undefined,
  missing: string,
) {
  const name = value?.businessName ?? value?.name;
  const registration = value?.registrationNumber;
  if (!name && !registration) return missing;
  const padded = registration ? registration.padStart(11, '0') : null;
  const document = padded ? (formatDocument(padded) ?? maskDocumentInput(padded)) : missing;
  return `${name ?? missing} | ${document}`;
}
